/* ObiHub OS — saf serializer/parser (sürüm 1).  Tarayıcı/depolama/yönlendirici API'si KULLANMAZ.
   Sözleşme: envelope yalnız {version, tabs}; sekme yalnız {kind, opaqueId, routeTemplate, params}; en çok 8 closeable sekme; çıktı ≤ 4 KB; deterministik.
   Bilinmeyen/fazla/hatalı HERHANGİ bir alan bütün envelope'u reddeder (null) — alanlar sessizce kırpılmaz, kısmi state üretilmez.
   Pinned sekmeler payload'a YAZILMAZ (registry'den yeniden kurulur).  Başlık/etiket/ad/numara/tutar/filtre/form/tam URL taşınamaz. */
const { PARAM_PATTERN, deepFreeze, validateParams } = require("./registry");

const VERSION = 1;
const MAX_TABS = 8;
const MAX_BYTES = 4096;
const ENVELOPE_KEYS = ["tabs", "version"];
const TAB_KEYS = ["kind", "opaqueId", "params", "routeTemplate"];

const hasExactKeys = (obj, keys) => {
  const own = Object.keys(obj).sort();
  return own.length === keys.length && own.every((k, i) => k === keys[i]);
};
const isPlainObject = (v) => v !== null && typeof v === "object" && !Array.isArray(v) && Object.getPrototypeOf(v) === Object.prototype;

/** Tek sekmeyi doğrular; geçerliyse dondurulmuş kanonik kopyasını, değilse null döner. Pinned kayıt `"pinned"` döner (atlanır). */
function checkTab(tab, registry) {
  if (!isPlainObject(tab) || !hasExactKeys(tab, TAB_KEYS)) return null;
  const entry = typeof tab.kind === "string" ? registry.get(tab.kind) : null;
  if (!entry) return null;
  if (entry.pinned) return "pinned";
  if (!entry.restorable || tab.routeTemplate !== entry.routeTemplate) return null;
  if (typeof tab.opaqueId !== "string" || !PARAM_PATTERN.test(tab.opaqueId) || !isPlainObject(tab.params)) return null;
  const params = validateParams(entry, tab.params);
  if (!params || params[entry.idParam] !== tab.opaqueId) return null;
  return { kind: entry.kind, opaqueId: tab.opaqueId, routeTemplate: entry.routeTemplate, params: Object.freeze(Object.fromEntries(Object.keys(params).sort().map((k) => [k, params[k]]))) };
}

function checkTabs(list, registry, { allowPinned }) {
  if (!Array.isArray(list)) return null;
  const out = [];
  const seen = new Set();
  for (const raw of list) {
    const t = checkTab(raw, registry);
    if (t === null) return null;
    if (t === "pinned") {
      if (!allowPinned) return null;
      continue;
    }
    const id = `${t.kind}:${t.opaqueId}`;
    if (seen.has(id)) return null;
    seen.add(id);
    out.push(t);
  }
  return out.length <= MAX_TABS ? out : null;
}

function serializeWorkspace(workspace, registry) {
  try {
    if (!isPlainObject(workspace) || !hasExactKeys(workspace, ["tabs"])) return null;
    const tabs = checkTabs(workspace.tabs, registry, { allowPinned: true });
    if (tabs === null) return null;
    const json = JSON.stringify({ version: VERSION, tabs: tabs.map((t) => ({ kind: t.kind, opaqueId: t.opaqueId, params: t.params, routeTemplate: t.routeTemplate })) });
    return json.length <= MAX_BYTES ? json : null;
  } catch (e) {
    return null;
  }
}

function parseWorkspace(raw, registry) {
  try {
    if (typeof raw !== "string" || raw.length === 0 || raw.length > MAX_BYTES) return null;
    const data = JSON.parse(raw);
    if (!isPlainObject(data) || !hasExactKeys(data, ENVELOPE_KEYS) || data.version !== VERSION) return null;
    const tabs = checkTabs(data.tabs, registry, { allowPinned: false });
    if (tabs === null) return null;
    return deepFreeze({ tabs });
  } catch (e) {
    return null;                                     // ham parse hatası dışarı sızmaz
  }
}

export { VERSION, MAX_TABS, MAX_BYTES, serializeWorkspace, parseWorkspace, checkTab };
